export default __webpack_public_path__ + "static/media/dark.d2a17b71.svg";